import React from "react";
import { Field, reduxForm } from "redux-form";
import ValidatedInputField from "../../common/form/ValidatedInputField";
import { validateParkMachine } from "./validateParkMachine.js";
import SubmitButton from "../../common/SubmitButton";
import { injectIntl } from "react-intl";
import afterSubmitFail from "../../common/form/focusAfterSubmitFail";
import ResetButton from "../../common/ResetButton";
import ReactSelect from "../../common/ReactSelect";
import DropDownOptions from "../../helpers/DropDownOptions";

class ParkMachineForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            handleSubmit,
            handleReset,
            parkMachineCategories,
            isUpdate,
        } = this.props;

        return (
            <form onSubmit={handleSubmit} noValidate={true}>
                <Field
                    type="text"
                    name="brand"
                    component={ValidatedInputField}
                    placeholder="Mærke"
                    className="form-control"
                    label="Mærke"
                />
                <Field
                    type="text"
                    name="model"
                    component={ValidatedInputField}
                    placeholder="Model"
                    className="form-control"
                    label="Model"
                />

                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>Kategori</b>
                    </label>
                    <div className="col-sm-10">
                        <Field
                            type="select"
                            name="categoryId"
                            component={ReactSelect}
                            options={DropDownOptions.getOptions(
                                parkMachineCategories,
                                "id",
                                "name"
                            )}
                            placeholder="- Vælg kategori -"
                        />
                    </div>
                </div>
                <Field
                    type="text"
                    name="quantity"
                    component={ValidatedInputField}
                    placeholder="Antal"
                    className="form-control"
                    label="Antal"
                />
                {
                    this.props.initialValues.photo
                    &&
                    <div className="form-group row">
                        <div className="col-sm-10 offset-sm-2">
                            <img style={{width: "300px"}} src={this.props.initialValues.photo.filePath} />
                        </div>
                    </div>
                }

                <div className="form-group row">
                    <div className="col-sm-10 offset-sm-2">
                        <label className="custom-control custom-checkbox">
                            <Field
                                name="statusCode"
                                type="checkbox"
                                component="input"
                                className="custom-control-input"
                            />
                            <span className="custom-control-indicator"> </span>
                            <span className="custom-control-description">Aktiv</span>
                        </label>
                    </div>
                </div>

                <div className="form-group row">
                    <div className="col-sm-10 offset-sm-2">
                        <label className="custom-control custom-checkbox">
                            <Field
                                name="removeImage"
                                type="checkbox"
                                component="input"
                                className="custom-control-input"
                            />
                            <span className="custom-control-indicator"> </span>
                            <span className="custom-control-description">Fjern billede</span>
                        </label>
                    </div>
                </div>

                <div className="form-group row">
                    <div className="col-sm-2">
                        <label><b>Billede</b></label>
                    </div>
                    <div className="col-sm-10">
                        <input type="file" name="image" onChange={this.props.onParkMachinePhotoChange}/>
                    </div>
                </div>

                <div className="form-group row">
                    <div className="col-sm-12">
                        <div className="offset-sm-2">
                            <SubmitButton isUpdate={isUpdate} />
                            <ResetButton onClick={handleReset} />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

ParkMachineForm = reduxForm({
    form: "park-machine-form",
    validate: validateParkMachine,
    onSubmitFail: afterSubmitFail
})(ParkMachineForm);

export default injectIntl(ParkMachineForm);



// WEBPACK FOOTER //
// ./web/src/components/park-machine/park-machine/ParkMachineForm.jsx